import styled from 'styled-components';

export const FooterLinkBlocks = styled.div`
  display: flex;

  @media (min-width: 1200px) {
    padding: 4rem 0;
  }

  @media (max-width: 1199px) {
    padding: 3rem 0;
  }

  @media (max-width: 767.98px) {
    flex-wrap: wrap;
  }

  @media (max-width: 767.98px) {
    justify-content: center;
    width: 480px;
    margin: 0px auto;
  }

  @media (max-width: 575.98px) {
    justify-content: center;
    width: 378px;
    margin: 0px auto;
  }

  @media (max-width: 575.98px) {
    width: 272px;
    padding: 0px;
    justify-content: space-between;
    gap: 16px;
  }
`;
